<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import {
  LibraryStepStatusDataQuery,
  LibraryStepStatusDataQueryVariables,
} from '@/generated/graphql'

const props = defineProps<{
  stepId: string
}>()

const { t } = useI18n()

const fetchQuery = useQuery<LibraryStepStatusDataQuery, LibraryStepStatusDataQueryVariables>(
  gql`
    query LibraryStepStatusData($id: ID!) {
      product {
        step(id: $id) {
          id
          detachedFromLibrary
        }
      }
    }
  `,
  () => ({ id: props.stepId }),
)

const step = computed(() => fetchQuery.result.value?.product.step)
</script>

<template>
  <v-alert
    v-if="step?.detachedFromLibrary"
    variant="tonal"
    density="compact"
    border="start"
    icon="link_off"
    class="mb-4"
  >
    <div class="text-subtitle-2">{{ t('component.libraryStepStatus.detached') }}</div>
    <p class="text-body-2">{{ t('component.libraryStepStatus.detachedMessage') }}</p>
  </v-alert>
</template>
